import bg from '../assets/bg.png';
import overlaybg from '../assets/overlaybg.png';
import welcome from '../assets/welcome.png';
import mirodeliceLogo from '../assets/mirodeliceLogo.png';
import bg2 from '../assets/bg2.png';
import bobun from '../assets/bobun.png';
import loclac from '../assets/loclac.png';
import nouilles from '../assets/Nouille.png';
import nouilleSauter from '../assets/nouilleSaute.png';
import pokebowl from '../assets/pokebowl.png';
import rizPoulet from '../assets/rizPoulet.png';
import vapeur from '../assets/vapeur.png';
import vecteur from '../assets/vecteur.png';
import vermicellePoulet from '../assets/vermicellePoulet.png';
import padThai from '../assets/padThai.png';
import sushiCalifornia from '../assets/sushiCalifornia.png';
import chaleureux from '../assets/chaleureux.png';
import etoiles from '../assets/etoiles.png';
import faitMaison from '../assets/faitMaison.png';
import halal from '../assets/halal.png';
import niveauHigiene from '../assets/niveauHigiene.png';
import plats from '../assets/plats.png';
import restau1 from '../assets/restau1.png';
import restau2 from '../assets/restau2.png';
import restau3 from '../assets/restau3.png';
import restau4 from '../assets/restau4.png';
import restau5 from '../assets/restau5.png';
import ellipse from '../assets/ellipse.png';
import chopstick from '../assets/chopstick.png';
import chopstickSide from '../assets/chopsticksSide.png';
import lantern from '../assets/lantern.png';
import wok from '../assets/wok.png';
import smiling from '../assets/smiling-face-joypixels.gif';
import stew from '../assets/stew.gif';
import lanternGif from '../assets/lantern.gif';
import fryingPan from '../assets/frying-pan.gif';

export default {
  bg,
  overlaybg,
  welcome,
  mirodeliceLogo,
  bg2,
  bobun,
  loclac,
  nouilles,
  nouilleSauter,
  pokebowl,
  rizPoulet,
  vapeur,
  vecteur,
  vermicellePoulet,
  padThai,
  sushiCalifornia,
  chaleureux,
  etoiles,
  faitMaison,
  halal,
  niveauHigiene,
  plats,
  restau1,
  restau2,
  restau3,
  restau4,
  restau5,
  ellipse,
  chopstick,
  chopstickSide,
  lantern,
  wok,
    smiling,
    stew,
    lanternGif,
    fryingPan,



};
